var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wcc footer"},[_c('p',[_vm._v("The calculations provided above, while deemed correct, cannot be guaranteed.")]),_c('p',[_vm._v("© "+_vm._s(_vm.year)+" Macdonald Realty Westmar")])])}
var staticRenderFns = []

export { render, staticRenderFns }